import { FORTA_BLUE, FORTA_WHITE } from '../../../../../utils/colors';

export const QUESTIONNAIRE_SECTION_TITLE_SX = {
  textAlign: 'left',
  fontWeight: 'bold',
  color: FORTA_BLUE.primary,
  mb: 1,
} as const;

export const QUESTIONNAIRE_SEND_ROW_SX = {
  p: 1,
  mt: 1,
  backgroundColor: FORTA_WHITE,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 1,
} as const;

export const QUESTIONNAIRE_ID_LINK_SX = {
  color: FORTA_BLUE.primary,
  textDecoration: 'underline',
  cursor: 'pointer',
  width: 'fit-content',
} as const;

export const QUESTIONNAIRE_DOCUMENT_SECTION_SX = {
  p: 3,
  mt: 1,
  backgroundColor: FORTA_WHITE,
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
} as const;

export const QUESTIONNAIRE_DOCUMENT_FIELDS_SX = {
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  flexWrap: 'wrap',
} as const;

export const QUESTIONNAIRE_DOCUMENT_AUTOCOMPLETE_SX = {
  width: 300,
} as const;

export const QUESTIONNAIRE_SELECT_AUTOCOMPLETE_SX = {
  width: 440,
} as const;

export const UPLOADED_DOCUMENT_LIST_SX = {
  width: '100%',
  mt: 1,
} as const;

export const UPLOADED_DOCUMENT_HEADING_SX = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  mb: 1,
} as const;

export const UPLOADED_DOCUMENT_ROW_SX = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 2,
  py: 1,
  px: 1.5,
  borderBottom: '1px solid',
  borderColor: 'divider',
  cursor: 'pointer',
  '&:hover': { backgroundColor: FORTA_BLUE.light3 },
  '&:focus-visible': { outline: `2px solid ${FORTA_BLUE.primary}`, outlineOffset: -2 },
} as const;

export const UPLOADED_DOCUMENT_META_SX = {
  textAlign: 'right',
  color: 'text.secondary',
  whiteSpace: 'nowrap',
} as const;
